import Model, { ID } from 'src/models/model'

export default class JobLogType extends Model {
  static name = 'JobLogType'

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      name: {
        type: String,
        output: true
      },
      isSubType: {
        type: Boolean,
        output: true
      }
    }
  }
}
